import { useState } from 'react';

export const useDisplayAwardsTable: () => [boolean, () => void] = () => {
  const [displayAwardsTable, setDisplayAwardsTable] = useState(false);
  const onDisplayAwardsTable = () => setDisplayAwardsTable(true);

  return [displayAwardsTable, onDisplayAwardsTable];
};
